import { useState } from "react";
import arrow from "../../Assets/img/icons/arrow_down.png";
import OutsideClickHandler from "react-outside-click-handler";

export function StakingProductDropDown({
  options,
  onChange,
  placeholder,
  className = "",
  error,
  value,
}) {
  const [isOpen, setIsOpen] = useState(false);

  function onClickItem(item) {
    onChange(item);
    setIsOpen(false);
  }

  function toggleDropDown() {
    setIsOpen((prev) => !prev);
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="card__product__row">
        {error?.error && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "-14px" }}>
            {Array.isArray(error?.error?.message)
              ? error.error.message[0]
              : error?.error?.message}
          </div>
        )}

        <div
          className="card__product__title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "215px",
            alignItems: "center",
          }}
          onClick={toggleDropDown}
        >
          {value?.label ?? placeholder}

          <img
            src={arrow}
            className="card__product__arrow"
            style={{ width: "10px", height: "6px", marginRight: "10px" }}
            alt="arrow"
          />
        </div>

        <div
          className={`product__row__dropdown ${isOpen ? "open" : ""} ${className}`}
        >
          {options.length > 0 ? (
            options.map((e, index) => (
              <div
                className={`product__row__dropdown__item ${
                  value?.value === e.value ? "selected" : ""
                }`}
                key={index}
                onClick={() => onClickItem(e)}
              >
                {e.label}
              </div>
            ))
          ) : (
            <div className="product__row__dropdown__item">
              No options available
            </div>
          )}
        </div>
      </div>
    </OutsideClickHandler>
  );
}
